( function() {
    "use strict";

    angular
        .module( 'ccsTrApp' )
        .controller( 'ShipmentExportBillPreviewController', ShipmentExportBillPreviewController );

    ShipmentExportBillPreviewController.$inject = [ 'entity', '$uibModalInstance', 'PDFExportService', 'ToastrService' ];

    function ShipmentExportBillPreviewController( entity, $uibModalInstance, PDFExportService, ToastrService ) {

        var vm = this;

        vm.shipment = entity;

        vm.close = close;
        vm.download = download;

        function close() {
            $uibModalInstance.dismiss( 'cancel' );
        }

        function download() {
            PDFExportService.downloadShipmentExportBillPDF( vm.shipment.id ).then( function( data, status, headers, config ) {
                var file = new Blob([data.data], {type: 'application/pdf'});
                saveAs(file, "Export Bill - " + vm.shipment.shipmentSiNum + '.pdf');
            }, function(error) {
                ToastrService.error("Something went wrong", "Error!");
            });
        }

    }
})();
